import { render, staticRenderFns, recyclableRender, components } from "./cu-video.vue?vue&type=template&id=10b27aa0&"
var renderjs
import script from "./cu-video.vue?vue&type=script&lang=js&"
export * from "./cu-video.vue?vue&type=script&lang=js&"
import style0 from "./cu-video.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!F:\\软件\\HBuilderX.2.3.3.20190923.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\软件\\HBuilderX.2.3.3.20190923.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b27aa0')) {
      api.createRecord('10b27aa0', component.options)
    } else {
      api.reload('10b27aa0', component.options)
    }
    module.hot.accept("./cu-video.vue?vue&type=template&id=10b27aa0&", function () {
      api.rerender('10b27aa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "E:/uni_app/douyin/douyin/components/cu-video.vue"
export default component.exports